const groupBuying = [
  {
    path: "/groupBuying",
    name: "groupBuying",
    meta: {
      title: "拼单",
      requireAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "groupBuying" */ "@/views/groupBuying/groupBuying.vue")
  },
  {
    path: "/groupBuying/list/:id",
    name: "groupBuyingList",
    meta: {
      title: "",
      keepAlive: true,
      requireAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "groupBuyingList" */ "@/views/groupBuying/list/list.vue")
  },
  {
    path: "/groupBuying/over",
    name: "groupBuyingOver",
    meta: {
      title: "拼单",
      requireAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "groupBuyingOver" */ "@/views/groupBuying/over/over.vue")
  },
  {
    path: "/groupBuying/join",
    name: "groupBuyingJoin",
    meta: {
      title: "拼单",
      requireAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "groupBuyingJoin" */ "@/views/groupBuying/join/join.vue")
  },
  {
    path: "/groupBuying/detail",
    name: "groupBuyingDetail",
    meta: {
      title: "订单详情",
      requireAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "groupBuyingDetail" */ "@/views/groupBuying/detail/detail.vue")
  },
  {
    path: "/groupBuying/orders",
    name: "groupBuyingOrders",
    meta: {
      title: "我的订单",
      keepAlive: true,
      requireAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "groupBuyingOrders" */ "@/views/groupBuying/orders/orders.vue")
  }
];

export default groupBuying;
